<template>
	<div class="login">
		<p class="loginTit">欢迎使用 一鸣 在线音乐系统</p>
		<div class="loginForm">
			<div class="logo">
				<img src="../assets/inm_logo.png" class="inmLogo" />
			</div>
			<div class="username2 mt-15">
				<div class="userTxt2">店铺编号</div>
				<input class="user2" v-model="username" type="text" name="username" placeholder="请输入店铺编号" />
			</div>
			<div class="password2">
				<div class="userTxt2">密码</div>
				<input class="passwordInput2" @keyup.enter="handleLogin" name="password" v-model="password" type="password"
				 placeholder="请输入密码" />
			</div>
			<p class="forgetTip">
				<span class="forgetTxt" @click="forgetPassword">重置密码</span>
			</p>
			<div class="loginBtn" @click="handleLogin">
				登 录
			</div>
			<p class="register">
				<span class="registerTxt" @click="createUser">创建账号</span>
			</p>
		</div>
	</div>
</template>

<script>
	import {
		Login
	} from '../request/api.js'
	export default {
		name: 'Home',
		components: {

		},
		data() {
			return {
				username: localStorage.getItem("loginname")||'',
				password: localStorage.getItem("loginpass")||''
			}
		},
		methods: {
			async handleLogin() {
				const res = await Login({
					username: this.username,
					password: this.password,
					rememberMe: true
				})
				if (res.code == 0) {
					this.toast("登录成功")
					localStorage.setItem("loginname",this.username)
					localStorage.setItem("loginpass",this.password)
					setTimeout(() => {
						if (!res.user.userLevel) {
							this.$router.push({
								path: '/chooseStyle'
							})
						} else {
							localStorage.setItem("typeIndex", res.user.userLevel)
							this.$router.push({
								path: '/home'
							})
						}
					}, 1200)
					localStorage.setItem('token', res.token)
					localStorage.setItem('userInfo', JSON.stringify(res.user))

				}
			},
			createUser() {
				this.$router.push({
					path: '/register'
				})
			},
			forgetPassword() {
				this.$router.push({
					path: '/forgetPassWord'
				})
			}
		}
	}
</script>
